import React from "react";
import { FileDown, FileSpreadsheet } from "lucide-react";
import { API, getToken } from "../../lib/api";
import { Button } from "../core/Button";

export function ExportButtons({ path, params, testIdPrefix }: { path: string; params: Record<string, string | number | undefined>; testIdPrefix: string }) {
  const href = (format: "pdf" | "xlsx") => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== "") q.set(k, String(v)); });
    q.set("format", format);
    q.set("auth", getToken() || "");
    return `${API}${path}?${q.toString()}`;
  };
  return (
    <div className="flex gap-2">
      <a href={href("xlsx")} data-testid={`${testIdPrefix}-export-xlsx`}><Button variant="secondary" type="button"><FileSpreadsheet className="h-4 w-4" />Excel</Button></a>
      <a href={href("pdf")} data-testid={`${testIdPrefix}-export-pdf`}><Button type="button"><FileDown className="h-4 w-4" />PDF</Button></a>
    </div>
  );
}

export function Breakdown({ title, data, labels, testId }: { title: string; data: Record<string, number>; labels?: Record<string, string>; testId: string }) {
  const entries = Object.entries(data).filter(([, n]) => n > 0);
  const max = Math.max(1, ...entries.map(([, n]) => n));
  return (
    <div data-testid={testId}>
      <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-600">{title}</p>
      {entries.length === 0 ? <p className="text-xs text-slate-400">No data</p> : (
        <ul className="space-y-1.5">{entries.map(([k, n]) => (
          <li key={k} className="text-xs"><div className="flex justify-between"><span className="font-medium text-slate-700">{labels?.[k] || k}</span><span className="text-slate-500">{n}</span></div><div className="mt-0.5 h-1.5 rounded-full bg-slate-100"><div className="h-1.5 rounded-full" style={{ width: `${(n / max) * 100}%`, background: "var(--brand)" }} /></div></li>
        ))}</ul>
      )}
    </div>
  );
}
